"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedoActive = void 0;
const react_redux_1 = require("react-redux");
const selectors_1 = require("../selectors");
const useSelector_1 = require("./useSelector");
function useRedoActive(isToolsMode = false) {
    /**
     * Fix global selector usage
     */
    const isToolsRedoActive = (0, react_redux_1.useSelector)(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.toolsOptions) === null || _a === void 0 ? void 0 : _a.isRedoActive; });
    const isGlobalRedoActive = (0, useSelector_1.useSelector)(selectors_1.getRedoActive);
    if (isToolsMode) {
        return isToolsRedoActive;
    }
    return isGlobalRedoActive;
}
exports.useRedoActive = useRedoActive;
